export default __webpack_public_path__ + "static/media/ico_que.9ee15c6b.svg";